import type {
	ItemFeedback,
	ItemFeedbackEntry,
} from "@memorang/types/src/session/new-session";
import i18next from "i18next";

export const findFeedbackByLanguage = (
	feedback: ItemFeedback | undefined,
): ItemFeedbackEntry | undefined => {
	if (!feedback || feedback.length === 0) {
		return undefined;
	}

	const targetLanguage = (i18next.language || "en-US").toLowerCase();

	let match = feedback.find(
		(entry) => entry.language.toLowerCase() === targetLanguage,
	);

	if (!match) {
		const languageCode = targetLanguage.split("-")[0];
		match = feedback.find((entry) =>
			entry.language.toLowerCase().startsWith(languageCode),
		);
	}

	return match || feedback[0];
};
